'use client';

import { useLayoutEffect, type ReactNode } from 'react';
import { subscribeConsent } from '@/contexts/consent/store';
import { clarityClient } from '@/contexts/clarity/client';

export function ClarityProvider({ children }: {
    /** 应用子树，不等待 Clarity 加载。 */
    children: ReactNode;
}) {
    useLayoutEffect(() => {
        const unsubscribe = subscribeConsent(clarityClient.syncConsent);
        void clarityClient.start();
        return () => { unsubscribe(); clarityClient.dispose(); };
    }, []);
    return children;
}

export const resetClarityIdentity = clarityClient.resetIdentity;
